<template>
  <div class="wrapper">
    <div class="main-panel">
      
      <div class="d-flex justify-content-end" >
        <div class="col-10 p-0">
          <dashboard-content></dashboard-content>
        </div>
        
      </div>
     
      <content-footer></content-footer>
     
    </div>
   
    <b-sidebar shadow visible style="background-color: #00948a!important;">
        
        <div class="d-flex justify-content-center text-center w-100">
                
          <img class="mt-3 justify-content-center" :src="url" alt=""  style="max-width: 100%; background-color: white;">
             
        </div>
        <div class="d-flex justify-content-center">
          <b-dropdown id="dropdown-1" :text="username" class="m-md-2 ">
            <b-dropdown-item to="/dashboard/Profile">Profile</b-dropdown-item>
            <b-dropdown-item  @click="onLogout">
              <div style="color:red"> <svg viewBox="0 0 16 16" width="1em" height="1em" focusable="false" role="img" aria-label="box arrow right" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="currentColor" class="bi-box-arrow-right b-icon bi"><g><path fill-rule="evenodd" d="M10 12.5a.5.5 0 0 1-.5.5h-8a.5.5 0 0 1-.5-.5v-9a.5.5 0 0 1 .5-.5h8a.5.5 0 0 1 .5.5v2a.5.5 0 0 0 1 0v-2A1.5 1.5 0 0 0 9.5 2h-8A1.5 1.5 0 0 0 0 3.5v9A1.5 1.5 0 0 0 1.5 14h8a1.5 1.5 0 0 0 1.5-1.5v-2a.5.5 0 0 0-1 0v2z"></path><path fill-rule="evenodd" d="M15.854 8.354a.5.5 0 0 0 0-.708l-3-3a.5.5 0 0 0-.708.708L14.293 7.5H5.5a.5.5 0 0 0 0 1h8.793l-2.147 2.146a.5.5 0 0 0 .708.708l3-3z"></path></g></svg> Logout</div>
             </b-dropdown-item>
        
          </b-dropdown>
        </div>
        <div id="nav" style="font-size: 14px;">
          
            <div class=" rounded-lg py-2 px-4 button-bcl " style="padding-right: 0rem !important;" data-toggle="collapse">
              <!--<b-icon-bar-chart-line font-scale="1.5"></b-icon-bar-chart-line>-->
              <router-link  class=" text-white" to="/dashboard/EntomologicalData" >Entomological Data</router-link>
              
            </div>
     
       
          <div class=" rounded-lg py-2 px-4 button-bcl" style="padding-right: 0rem !important;" data-target="#Entomological" data-toggle="collapse">
            <!--<b-icon-graph-up font-scale="1.5"></b-icon-graph-up>-->
              <a class=" text-white " aria-expanded="false">Epidemiological Data</a>
            <b-icon-caret-down-fill></b-icon-caret-down-fill>
            <ul class="collapse px-3 py-1" id="Entomological" @click.stop style="padding-right: 0rem !important;">
              <li class="py-1"><router-link class="p-1 text-white" to="/dashboard/WestNileVirus" >West Nile Virus</router-link></li>
            </ul>
          </div>
        

          <div class=" rounded-lg py-2 px-4 button-bcl" style="padding-right: 0rem !important;" href="#mosquitoes" data-toggle="collapse">
            <!--<b-icon-graph-up font-scale="1.5"></b-icon-graph-up>-->
            <a class=" text-white " aria-expanded="false">Mosquitoes' Abundance Predictions</a>
            <b-icon-caret-down-fill></b-icon-caret-down-fill>
            <ul class="collapse px-3 py-1" id="mosquitoes" @click.stop  style="padding-right: 0rem !important;">
              <li class="py-1"><router-link class="p-1 text-white" to="/dashboard/Mosquitoes-Abundance/Culex" >Culex</router-link></li>
              <li class="py-1"><router-link class="p-1 text-white" to="/dashboard/Mosquitoes-Abundance/Aedes" >Aedes</router-link></li>
              <li class="py-1"><router-link class="p-1 text-white" to="/dashboard/Mosquitoes-Abundance/Anopheles">Anopheles</router-link></li>
            
            </ul>
          </div>

          <div class=" rounded-lg py-2 px-4 button-bcl " style="padding-right: 0rem !important;" data-toggle="collapse">
              <!--<b-icon-bar-chart-line font-scale="1.5"></b-icon-bar-chart-line>-->
              <router-link  class=" text-white" to="/dashboard/MosquitoBorneDieseasesRiskPredictions" >Mosquito Borne Diseases Risk Predictions</router-link>
              
          </div>

          <div class=" rounded-lg py-2 px-4 button-bcl" style="padding-right: 0rem !important;" data-target="#Human_cases_risk" data-toggle="collapse">
              <!--<b-icon-graph-up font-scale="1.5"></b-icon-graph-up>-->
              <a class=" text-white " aria-expanded="false">Human Cases Risk <br>Predictions</a>
              <b-icon-caret-down-fill></b-icon-caret-down-fill>
              <ul class="collapse px-3 py-1" id="Human_cases_risk" @click.stop style="padding-right: 0rem !important;">
                <li>
                  <div>
                    <a v-b-toggle.collapse-3 class="px-1 text-white">West Nile Virus</a>
                    <b-icon-caret-down-fill></b-icon-caret-down-fill>
                    <b-collapse id="collapse-3">
                      <ul style="padding-right: 0rem !important;">
                        <li class="py-1"><router-link class="p-1 text-white" to="/dashboard/West-Nile-Virus/Municipality" >Municipality level</router-link></li>
                        <li class="py-1"><router-link class="p-1 text-white" to="/dashboard/West-Nile-Virus/Settlement">Settlement level</router-link></li>
                      </ul>
                    </b-collapse>
                  </div>
                </li>
              </ul>
            </div>
         



        <div class="px-4 py-3" v-if="group[0].name==='view_all'">
          <b-button v-b-modal.modal-1 variant="light" style="font-size: 14px;">EYWAopenAPI</b-button>
          
          <b-modal id="modal-1"  size="lg" title="" hide-footer style="z-index: 1050;">
              <h3 class="font-weight-bold">EYWAopenAPI: </h3>
              <p class="font-weight-light">EYWA is an autonomous European Initiative, building upon the Open Innovation, Open Science and Open to the World vision for Europe. It incorporates the open data sharing principles by creating the “EYWAopenAPI” (http://epidemics.space.noa.gr/api_v2/) to ensure interoperability with GEOSS DAB API and other data harvesting standards used by GEOSS Portal, GEO-CRADLE Data Hub, etc.</p>
              <p class="font-weight-light my-3">The "EYWAopenAPI" (http://epidemics.space.noa.gr/api_v2/) is offering automatic retrieval of analysis ready environmental, meteorological and geomorphological remote sensing derived indexes that can be exploited by anyone involved in the health and epidemics domain. These environmental and climatic essential parameters may be related to not only mosquito-borne diseases, but to other types as well. The data are initially available for nine European regions at trap spatial analysis level.</p>
              <h5 class="font-weight-bold">URLS:</h5>
              <p class="font-weight-light">http://epidemics.space.noa.gr:8889/culex/v2/gr/</p>
              <p class="font-weight-light">http://epidemics.space.noa.gr:8889/culex/v2/</p>
              <p class="font-weight-light">http://epidemics.space.noa.gr:8889/aedes/v2/</p>
              <p class="font-weight-light">http://epidemics.space.noa.gr:8889/anopheles/v2/</p>

          </b-modal>

        </div>
        <div class="px-4">
          <b-button v-b-modal.modal-2 variant="light" style="font-size: 14px;">Reports</b-button>
          <b-modal id="modal-2"  size="lg" title="" hide-footer style="z-index: 1050;">
            <h3 class="font-weight-bold">Reports: </h3>
            <b-form-select  v-model="selectedCountry" class="mb-3" @change="ChangeCountry">
                      <!-- This slot appears above the options from 'options' prop -->
                      <template #first>
                        <b-form-select-option :value="null" disabled>-- Select country --</b-form-select-option>
                      </template>

                      <!-- These options will appear after the ones from 'options' prop -->
                      <b-form-select-option v-for="(country_name,index) in country_pdf_data" :key="index"  :value="country_name.name" >{{country_name.name}}</b-form-select-option>
            </b-form-select>
            <b-form-select v-if="selectedCountry==='Greece'"  v-model="selectedRegion" class="mb-3" >
                      <!-- This slot appears above the options from 'options' prop -->
                      <template #first>
                        <b-form-select-option :value="null" disabled>-- Select region --</b-form-select-option>
                      </template>

                      <!-- These options will appear after the ones from 'options' prop -->
                      <b-form-select-option v-for="(data,index) in regions" :key="index"  :value="data" >{{data}}</b-form-select-option>
            </b-form-select>
            <b-form-select  v-model="selectedYear" class="mb-3">
                    <!-- This slot appears above the options from 'options' prop -->
                    <template #first>
                      <b-form-select-option :value="null" disabled>-- Select Year --</b-form-select-option>
                    </template>
                    <!-- These options will appear after the ones from 'options' prop-->
                    <b-form-select-option v-for="(data,index) in years"
                                          :key="index"
                                          :value="data" >{{data}}</b-form-select-option>
            </b-form-select>
            <div v-if="selectedCountry">
              <div class="" style="overflow:scroll; overflow-x: hidden; max-height: 40vh;" > 
              <div v-for="(pdf,index) in country_pdf" :key="index" >
                <b-button @click="Readpdf(pdf.pdf_name[0])" variant="outline-secondary" class="mt-2" v-if="pdf.year===selectedYear && pdf.region===selectedRegion"  target="_blank">
                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-file-earmark-pdf-fill" viewBox="0 0 16 16">
                    <path d="M5.523 12.424c.14-.082.293-.162.459-.238a7.878 7.878 0 0 1-.45.606c-.28.337-.498.516-.635.572a.266.266 0 0 1-.035.012.282.282 0 0 1-.026-.044c-.056-.11-.054-.216.04-.36.106-.165.319-.354.647-.548zm2.455-1.647c-.119.025-.237.05-.356.078a21.148 21.148 0 0 0 .5-1.05 12.045 12.045 0 0 0 .51.858c-.217.032-.436.07-.654.114zm2.525.939a3.881 3.881 0 0 1-.435-.41c.228.005.434.022.612.054.317.057.466.147.518.209a.095.095 0 0 1 .026.064.436.436 0 0 1-.06.2.307.307 0 0 1-.094.124.107.107 0 0 1-.069.015c-.09-.003-.258-.066-.498-.256zM8.278 6.97c-.04.244-.108.524-.2.829a4.86 4.86 0 0 1-.089-.346c-.076-.353-.087-.63-.046-.822.038-.177.11-.248.196-.283a.517.517 0 0 1 .145-.04c.013.03.028.092.032.198.005.122-.007.277-.038.465z"/>
                    <path fill-rule="evenodd" d="M4 0h5.293A1 1 0 0 1 10 .293L13.707 4a1 1 0 0 1 .293.707V14a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2zm5.5 1.5v2a1 1 0 0 0 1 1h2l-3-3zM4.165 13.668c.09.18.23.343.438.419.207.075.412.04.58-.03.318-.13.635-.436.926-.786.333-.401.683-.927 1.021-1.51a11.651 11.651 0 0 1 1.997-.406c.3.383.61.713.91.95.28.22.603.403.934.417a.856.856 0 0 0 .51-.138c.155-.101.27-.247.354-.416.09-.181.145-.37.138-.563a.844.844 0 0 0-.2-.518c-.226-.27-.596-.4-.96-.465a5.76 5.76 0 0 0-1.335-.05 10.954 10.954 0 0 1-.98-1.686c.25-.66.437-1.284.52-1.794.036-.218.055-.426.048-.614a1.238 1.238 0 0 0-.127-.538.7.7 0 0 0-.477-.365c-.202-.043-.41 0-.601.077-.377.15-.576.47-.651.823-.073.34-.04.736.046 1.136.088.406.238.848.43 1.295a19.697 19.697 0 0 1-1.062 2.227 7.662 7.662 0 0 0-1.482.645c-.37.22-.699.48-.897.787-.21.326-.275.714-.08 1.103z"/>
                  </svg>
                  {{pdf.pdf_name[0]}}
                </b-button>
              
              </div>
              </div>
            </div>
          </b-modal>
        </div>

        </div>


       
        <template #footer="{  }">
          <img src="/img/logo.png" style="width: 100%; background-color: white;" class="align-self-end">
      </template>
      </b-sidebar>

  </div>



</template>

<script>
  import TopNavbar from './TopNavbar.vue'
  import ContentFooter from './ContentFooter.vue'
  import DashboardContent from './Content.vue'
  import MobileMenu from './MobileMenu.vue'
  import axios from '../axios-auth'
  export default {
   
    async created() {
      var user =JSON.parse(localStorage.getItem('user'))
      this.group = user.groups
      const token = localStorage.getItem('token')
      const country_pdf_all = await axios.get('json-pdf/',{params:{group:JSON.stringify(this.group)},  headers: { Authorization: `Bearer ${token}`}})////.catch(error=> routes.replace('/'))
      this.country_pdf_data=country_pdf_all.data

      await this.$store.dispatch('fetchUser')
      console.log(this.$store.getters.user[0])
      if(this.$store.getters.user[0].logo_path){
        this.url=this.$store.getters.user[0].logo_path
      }
      console.log(this.url)
     // console.log(this.country_pdf_data)
    },
    data(){
      return{
        sidebar:true,
        url:"/img/beyond.jpg",
        group:null,
        selectedYear:null,
        selectedRegion:null,
        years:[],
        regions:[],
        selectedCountry:null,
        country_pdf_data:null,
        country_pdf:[],
        name:'Entomological Data'
      }
    },
    components: {
      TopNavbar,
      ContentFooter,
      DashboardContent,
      MobileMenu
    },
    computed: {
      
      username () {
        // console.log(this.$store.getters.user)
        return !this.$store.getters.user ? false : this.$store.getters.user[0].username
      }
    },
  
    methods: {
      onLogout() {
        //console.log("here")
        this.$store.dispatch('logout')

      },
      
      toggleSidebar () {
       // if (this.$sidebar.showSidebar) {
        //  this.$sidebar.displaySidebar(false)
        //}
      },
      noActive(){
        addEventListener('click', ()=> this.show = true)
      },
      ChangeCountry(){
        this.country_pdf=[]
        console.log(this.country_pdf_data)
        for(var i=0; i<this.country_pdf_data.length; i++){
          if(this.country_pdf_data[i].name===this.selectedCountry){
            this.years=this.country_pdf_data[i].year
            this.regions=this.country_pdf_data[i].region
            if(this.country_pdf_data[i].name!=='Greece'){
              this.selectedRegion=this.country_pdf_data[i].name
            }
            else{
              this.selectedRegion=null
            }
            //this.country_pdf.push({name:this.country_pdf_data[i].pdf_name,path:this.country_pdf_data[i].pdf_path})
            this.country_pdf=this.country_pdf_data[i].data
            break;
          }
        }
        //console.log(this.regions)
      },
      async Readpdf(name){
        //console.log(name)
        const token = localStorage.getItem('token')
        
        axios.get('view-pdf/', {  headers: { Authorization: `Bearer ${token}`} ,params: {name: name},responseType: 'blob'}).then(response => {
        //Create a Blob from the PDF Stream
        //console.log(response)
            const file = new Blob(
              [response.data], 
              {type: 'application/pdf'});
        //Build a URL from the file
        //console.log(file)
            const fileURL = URL.createObjectURL(file);
        //Open the URL on new Window
            window.open(fileURL);
        })
       ////.catch(error=> routes.replace('/'))
      }
     
    
      
    },
    
  }

</script>

<style>
.button-bcl:hover {
  background-color:rgba(236, 236, 236, 0.2);
}
.router-link-exact-active {
  color: #000000 !important;
}
.b-sidebar{
  background: #00948a!important;
  width: 15%;
  display: flex!important;
}
.dropdown-menu{
  top: 0 !important;
}
</style>
